export default "__VITE_ASSET__cd9445a8__"